import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12341655"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "queue-layout" }
const _hoisted_2 = {
  key: 0,
  class: "project-tasks-layout"
}
const _hoisted_3 = { class: "project-tasks-layout__main-content-skeleton" }
const _hoisted_4 = {
  key: 1,
  class: "queue-layout__header"
}
const _hoisted_5 = {
  key: 2,
  class: "queue-layout__content"
}

import {
  computed,
  ComputedRef,
  inject,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  PropType,
  provide,
  ref,
  watch,
} from 'vue';
import { QueueListIcon, ViewColumnsIcon } from 'tir-style-system/icons/outline';
import { RouterTabs, RouterTab, ParentTaskModel, ParentTaskPlate } from '@/components';
import { useRoute, useRouter } from 'vue-router';
import { AdapterService } from './adapter';
import { ProjectQueueTaskListItem } from '@/components/tasks-kanban/adapter';
import { CurrentUser } from 'tir-pm-user-core';
import { TirPmSkeletonLoader } from 'tir-components';
import { ProjectQueueTaskGetRequestModel } from './models';


export default /*#__PURE__*/_defineComponent({
  __name: 'queue-layout',
  props: {
  /**ID неймспейса */
  namespaceId: {
    type: String,
    required: true,
  },
  namespaceName: {
    type: String,
    required: true,
  },
},
  emits: ["checkIsUserAccessTask", "toggle-submenu", "open-options", "isNoQueueInformation"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();
const route = useRoute();

const adapter = new AdapterService();

/**Загрузка при инициализации */
const isInitLoading = ref(false);




/**Проверка приглашения */
const isInvited = inject<ComputedRef<boolean>>('isInvited');

/**Родительская задача */
const parentTask = ref<ParentTaskModel>();
/**Админ неймспейса */
const isOwner = ref(false);
const isAdminNamespace = ref(false);
const isAdminProject = ref(false);
const isCanAddTask = ref(false);
const currentQueue = ref(new ProjectQueueTaskListItem());
/**Отсутствие информации об очереди */
const isNoQueueInformation = ref(false);

const isVisibleHeader = computed(
  () =>
    router.currentRoute.value?.name &&
    ['kanban', 'list'].includes(router.currentRoute.value.name.toString()),
);

provide('isAdminNamespace', isAdminNamespace);
provide('currentQueue', currentQueue);
provide('isCanAddTask', isCanAddTask);
provide('isAdminProject', isAdminProject);
provide('isOwner', isOwner);

watch(
  () => props.namespaceId,
  async () => {
    isAdminNamespace.value = await adapter.checkNamespaceAdmin(props.namespaceId);
  },
);
watch(
  () => route.params.queueId,
  async () => {
    await updateQueue();
  },
);

onBeforeMount(async () => {
  isInitLoading.value = true;
  isAdminNamespace.value = await adapter.checkNamespaceAdmin(props.namespaceId);
  isInitLoading.value = false;
  await adapter.ToggleSubscribe(true);
  adapter.UpdateQueueTaskStatusEvent.on(updateQueue);
  await updateQueue();
});

/**Получение родительской задачи */
const getQueueParentTask = async (queueId: string) => {
  parentTask.value = undefined;
  const response = await adapter.getQueueParentTask(queueId);
  if (response.IsSuccess) {
    parentTask.value = response.Value;
  }
};
async function updateQueue() {
  const queueId = route.params.queueId?.toString();
  const taskId = route.params.taskId;
  if (queueId) {
    const res = await adapter.getQueueInfo(
      new ProjectQueueTaskGetRequestModel({ QueueTaskId: queueId }),
    );
    if (res.IsSuccess) {
      currentQueue.value = res.Value;
    } else {
      isNoQueueInformation.value = true;
      emit('isNoQueueInformation', true);
      if (!isInvited.value) {
        router.push({
          name: 'project-stub-page',
          query: {
            errorCode: res.ErrorCode,
          },
        });
      }
    }
    isCanAddTask.value = await IsCanAddTask();
    await getQueueParentTask(queueId);
  }
}

onBeforeUnmount(() => {
  adapter.ToggleSubscribe(false);
});

function onOpenOptions(queueId) {
  emit('open-options', queueId);
}

async function IsCanAddTask() {
  const user = CurrentUser;
  const isGood = user.Roles.includes(2); // owner
  isOwner.value = isGood;
  if (isGood) {
    isCanAddTask.value = true;
    return true;
  }
  const isProjectAdmin = await adapter.isProjectAdmin({
    ProjectId: route.params.projectId,
    UserId: user.Id,
  } as any);
  isAdminProject.value = Boolean(isProjectAdmin.Value);
  if (isProjectAdmin.Value) {
    isCanAddTask.value = true;
    return true;
  }

  if (isAdminNamespace.value) {
    isCanAddTask.value = true;
    return true;
  }

  const res = await adapter.getQueueUsersRoles({
    QueueTaskId: currentQueue?.value?.Id || route.params.queueId,
    UserId: user.Id,
  } as any);
  const xx = res.Value?.filter((el) => el?.Id == user?.Id);
  const resp = xx?.length > 0 && xx[0].Accesses.length > 0 && xx[0].Accesses[0]; //TODO: Добавить проверку на возможность добавления задачи
  isCanAddTask.value = resp;
  return resp;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isInitLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(TirPmSkeletonLoader), {
            width: "18.75rem",
            height: "2rem",
            "border-radius": "0.5rem"
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(TirPmSkeletonLoader), {
              width: "100%",
              height: "75rem",
              "border-radius": "0.5rem"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (isVisibleHeader.value && !isInitLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(RouterTabs), { class: "queue-layout__tabs" }, {
            default: _withCtx(({ currentTab }) => [
              _createVNode(_unref(RouterTab), {
                route: { name: 'kanban' },
                label: "Канбан",
                currentTab: currentTab
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ViewColumnsIcon), { class: "queue-layout__tab-icon kanban" })
                ]),
                _: 2
              }, 1032, ["currentTab"]),
              _createVNode(_unref(RouterTab), {
                route: { name: 'list' },
                label: "Список",
                currentTab: currentTab
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(QueueListIcon), { class: "queue-layout__tab-icon list" })
                ]),
                _: 2
              }, 1032, ["currentTab"])
            ]),
            _: 1
          }),
          (parentTask.value)
            ? (_openBlock(), _createBlock(_unref(ParentTaskPlate), {
                key: 0,
                task: parentTask.value
              }, null, 8, ["task"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!isInitLoading.value && (currentQueue.value?.Id || _unref(isInvited)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_RouterView, {
            onToggleSubmenu: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-submenu', $event))),
            onOpenOptions: onOpenOptions,
            onCheckIsUserAccessTask: _cache[1] || (_cache[1] = ($event: any) => (emit('checkIsUserAccessTask', $event))),
            namespaceName: __props.namespaceName,
            queueInfo: currentQueue.value,
            isNoQueueInformation: isNoQueueInformation.value
          }, null, 8, ["namespaceName", "queueInfo", "isNoQueueInformation"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})